import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { DATE_FORMAT } from "@/utils/constants/common";

dayjs.extend(utc);

// eslint-disable-next-line no-extend-native, func-names
Date.prototype.toJSON = function (): string {
  const timeDayObj = dayjs(this).startOf("day").utc(true);

  return !timeDayObj ? timeDayObj : dayjs(timeDayObj).format(DATE_FORMAT);
};
